import { HubApiMethods } from '../../constants/HubApiMethods';
import { HubJsonRpcRequest } from '../../api/HubJsonRpcRequest';

import { AcceptPolicyResponse } from '../../api/hub-responses/accept-policy-response';
import { HubApiError } from '../../domains/valueObject/SwitchUserProgressResponses';


export type AcceptPolicyRequest = {
    suid: string,
    policy_ids: number[]
    token: string
}

export function acceptPolicy(data: AcceptPolicyRequest): Promise<AcceptPolicyResponse|HubApiError> {
    return HubJsonRpcRequest.makeRequest<AcceptPolicyResponse, AcceptPolicyRequest>(
        HubApiMethods.ACCEPT_POLICY,
        data,
        window.app.deviceIdentifier
    );
}
